import type { UserRole } from "@/utils/userRole";

export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export const USER_TYPES = {
  INTERNAL: "internal",
  EXTERNAL: "external",
} as const;

export const DEFAULT_LANDING = "/pricing-audit-tool/instances";

// Where an external user lands per capability. Sales wins when they hold both,
// preserving the pre-existing /active-leads landing for today's users.
export const ACTIVE_LEADS_LANDING = "/active-leads";
export const PERFORMANCE_ANALYSIS_LANDING = "/performance-analysis";
// Portfolio grants neither capability — every gated route redirects here, so it
// must never itself be gated or the redirect would loop.
export const NO_CAPABILITIES_LANDING = "/no-access";

export type AuthUser = null | {
  email?: string;
  sub?: string;
  id?: string;
  name?: string;
  displayName?: string;
  preferred_username?: string;
  user_type?: string;
  user_org_scopes?: string[];
  // Resolved from the access token's role claims — see resolveUserRole.
  user_role?: UserRole;
  [key: string]: unknown;
};

export type AuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: AuthUser;
  accessToken: string | null;
};

export type KeycloakContextType = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: AuthUser;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
  getAccessToken: () => string | null;
};
